import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_904876781 from "../../../../../packages/component/src/components/breadcrumb/demo/demo1.js?loadDemo";
import legacyImportDemo_1636573390 from "../../../../../packages/component/src/components/breadcrumb/demo/demo2.js?loadDemo";
import legacyImportDemo_2158479663 from "../../../../../packages/component/src/components/breadcrumb/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_904876781,
  legacyImportDemo_1636573390,
  legacyImportDemo_2158479663,
  React
};